module.exports = __webpack_public_path__ + "static/user-most-likely-to-recommend-fall-b7296bcf338a362d11878d17da48c66d.svg";